import { intervalConfigurationGroupsOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

export const conf = defineEntity({
  ...entityFactory("time-preset"),
  endpoint: "interval-configuration-groups",
  operations: intervalConfigurationGroupsOps,
  roleView: [ROLE.CONTAINER_VIEW, ROLE.CONTAINER_ADMIN],
  roleAdmin: [ROLE.CONTAINER_ADMIN],
  singularName: (t) => t("Time preset"),
  name: (t) => t("Time presets"),
  syncCustomerFilter: true,
  dependencies: ["container"],
});

export default conf;
